/**
 * ChatQuestionType enum constant.
 */
export default {
    notSet: 0,
    textMessage: 1,
    suggestion: 2,
    menuItem: 3,
    welcomeIntent: 4,
    customIntent: 5
}
